module.exports = __webpack_public_path__ + "static/media/celine_french.d81013e6.mp3";